import { NgModule } from '@angular/core';
import { EmpusaMicroApp, EmpusaMicroAppType } from '@empusa/empusa-core';
import { MicroappHomeHomeModule } from './microapp-home.home.module';

@NgModule({
  declarations: [],
  imports: [],
  exports: []
})
export class MicroappHomeModule implements EmpusaMicroApp {
  name: string = "home";
  description: string = "Home Portal"
  icon: string = "home";
  page: any = MicroappHomeHomeModule;
  homeApp: boolean = true;
  path: string = "home";
  order: number = 1;
  resourceServerId: string = "keycloak-auth-manager-resources-server";
  appType: EmpusaMicroAppType = EmpusaMicroAppType.home;

  constructor() {
    //we register ourselves
    (<any>window).empusa(this);
    console.debug("Load microapp " + this.name);
  }
}
